/**
 * Argon Dashboard 2 PRO MUI - v3.0.1
 * Global styles with enhanced mobile/tablet support
 */

// Argon Dashboard 2 PRO MUI Base Styles
import colors from "assets/theme/base/colors";

const { info, dark } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
    height: "100%",
    WebkitOverflowScrolling: "touch", // Enable momentum scrolling on iOS
    overscrollBehavior: "none", // Prevent bounce/pull-to-refresh effects
  },

  body: {
    height: "100%",
    overflow: "auto",
    touchAction: "manipulation", // Improves touch performance
    textSizeAdjust: "100%", // Prevents iOS text size adjustment
  },

  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent", // Remove tap highlight on mobile
  },

  "a, a:link, a:visited": {
    textDecoration: "none !important",
    touchAction: "manipulation", // Faster touch response
  },

  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },

  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },

  hr: {
    borderBottom: 0,
    borderLeft: 0,
    borderRight: 0,
  },

  // Enhanced container styles for better mobile experience
  ".scrollable-container": {
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    overscrollBehavior: "contain",
    maxHeight: "100%",
  },

  // Fix for fixed position elements on mobile
  ".fixed-element": {
    position: "fixed",
    WebkitBackfaceVisibility: "hidden", // Prevents jittering during scrolling
  },

  // Prevent text selection during touch navigation
  ".no-select": {
    userSelect: "none",
  },

  // Responsive table improvements
  ".table-responsive": {
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "thin",
  },

  // Tablet specific optimizations (768px-1200px)
  "@media (min-width: 768px) and (max-width: 1200px)": {
    ".tablet-scroll-container": {
      overflowY: "auto !important",
      WebkitOverflowScrolling: "touch",
      height: "auto !important",
      maxHeight: "100vh",
    },

    // Fix for content that gets cut off on tablet
    ".tablet-full-height": {
      height: "auto !important",
      minHeight: "100%",
    },
  },

  // Mobile specific optimizations
  "@media (max-width: 767px)": {
    "input, select, textarea": {
      fontSize: "16px !important", // Prevents iOS zoom on focus
    },
  },
};

export default globals;
